import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  exchangeSchoolYearPath,
  nextYearStudentsPath,
  bulkUpsertStudents,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  fetchClasses,
  fetchNextClasses,
  fetchNextYearStudents,
  FETCH_CLASSES_SUCCESS_MESSAGE,
  FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
  BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentSpreadSheet from "../../../templates/manager/StudentSpreadSheet";
import { IStudentForRegister } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

const BulkEditNextYearStudents = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [filterByClass, setFilterByClass] = React.useState("");
  const [filterByYear, setFilterByYear] = React.useState("");
  const [fetched, setFetched] = React.useState({
    classes: false,
    next_classes: false,
  });
  const history = useHistory();
  const { currentYear, nextYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(nextYearStudentsPath);
    }
    if (state.success_message === FETCH_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, classes: true }));
      }, 100);
    }
    if (state.success_message === FETCH_NEXT_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, next_classes: true }));
      }, 100);
    }
  }, [dispatch, history, state.success_message]);

  const bulkUpsertStudentsFunc = React.useCallback(
    (students: IStudentForRegister[]) => {
      dispatch(peep(bulkUpsertStudents(students)));
    },
    [dispatch, peep],
  );

  const refetchData = React.useCallback(() => {
    dispatch(peep(fetchClasses(currentYear)));
    dispatch(peep(fetchNextClasses(currentYear + 1)));
    dispatch(peep(fetchNextYearStudents(filterByClass, filterByYear)));
  }, [dispatch, peep, filterByClass, filterByYear, currentYear]);

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    dispatch(fetchNextClasses(currentYear + 1));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  React.useEffect(() => {
    dispatch(fetchNextYearStudents(filterByClass, filterByYear));
  }, [filterByClass, filterByYear, dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
          {
            title: `${titles.nextYearStudents} (${nextYear}年度)`,
            to: nextYearStudentsPath,
          },
        ]}
        currentTitle={`${titles.bulkEditNextYearStudents} (${nextYear}年度)`}
      />
      {fetched.classes && fetched.next_classes && (
        <StudentSpreadSheet
          title={`${titles.bulkEditNextYearStudents} (${nextYear}年度)`}
          calling={calling}
          error={state.error}
          students={state.next_year_students}
          classes={state.classes}
          next_classes={state.next_classes}
          school={state.manager.school!}
          isNextYear={true}
          reset={refetchData}
          save={bulkUpsertStudentsFunc}
          onFilterByClass={setFilterByClass}
          onFilterByYear={setFilterByYear}
          plans={state.plans}
        />
      )}
    </div>
  );
};

export default BulkEditNextYearStudents;
